/**
 * Formata o número de um título GIRO no padrão XXX.XXX.
 *
 * Extrai apenas dígitos, preenche com zeros à esquerda até 6 dígitos
 * (ou usa os 6 da direita se houver mais) e insere o ponto após o terceiro.
 */
export function formatarNumeroGiro(valor: string | number | null | undefined): string {
    const digitos = String(valor ?? "").replace(/\D/g, "");
    if (!digitos) {
        return "";
    }

    const seis = digitos.length <= 6 ? digitos.padStart(6, "0") : digitos.slice(-6);
    return `${seis.slice(0, 3)}.${seis.slice(3)}`;
}
